import { Sprites } from "../../../utils/Sprites"
import { MakeVideoAtlases } from "../MakeVideoAssets"
import { MakeVideoSprite } from "../MakeVideoTypes"

export class MakeVideoIntroTateSprite implements MakeVideoSprite {
    private static SMOKING = "SMOKING"

    active: boolean
    private sprite: Phaser.Sprite

    constructor(game: Phaser.Game, group: Phaser.Group, x: number, y: number, debug: boolean) {
        this.sprite = Sprites.add(game, MakeVideoAtlases.INTRO_TATE, {debug, group, x, y})
        this.sprite.animations.add(MakeVideoIntroTateSprite.SMOKING, [1])
        this.active = true
    }

    destroy = () => {
        this.sprite.destroy(true)
        this.active = false
    }

    smokingCig = () => this.sprite.play(MakeVideoIntroTateSprite.SMOKING)
}